import styled, { css } from 'styled-components';

export const DraggerButtonSC = styled.div<{ size?: number }>`
  ${({ size }) =>
    css`
      width: fit-content;
      min-width: ${size}px;
      height: fit-content;
      min-height: ${size}px;
    `};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  border-radius: 10px;
  border: 2px solid ${({ theme }) => theme.color.border.regular};
  background: ${({ theme }) => theme.color.surface.variant};

  transition: all 0.2s;

  .ui-upload-disabled & {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }

  &:hover {
    border: 2px solid
      ${({ theme }) => theme.createOverlayColor(theme.color.border.regular, 'hover')};
    background: ${({ theme }) => theme.createOverlayColor(theme.color.surface.variant, 'hover')};
  }

  .ui-form-field-error & {
    border: 2px solid ${({ theme }) => theme.color.border.error} !important;
    background: ${({ theme }) => theme.color.surface.error};

    &:hover {
      border: 2px solid
        ${({ theme }) => theme.createOverlayColor(theme.color.border.error, 'hover')} !important;
      background: ${({ theme }) => theme.createOverlayColor(theme.color.surface.error, 'hover')};
    }
  }

  .ui-upload-drag-hover & {
    border: 2px solid ${({ theme }) => theme.color.solid.selection};
  }

  .ui-upload-drag-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
  }
`;
